import * as yup from 'yup';

export const schemalogin = yup.object().shape({
  IdEmpresa: yup.number('').required('ID da empresa é obrigatório'),
  Login: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
  Senha: yup.string().required('Senha é obrigatória')
  .min(6, 'Senha muito curta. Deve ter pelo menos 6 caracteres.'),
});